<!-- Scheduled maintenance notice — auto-hides after the window ends -->
<div class="server-maintenance-banner"
  [class.is-active]="isMaintenanceActive()"
  *ngIf="serverMaintenance.show && !serverMaintenance.dismissed"
  role="alert" aria-live="assertive">
  <div class="smb-inner">
    <div class="smb-icon" aria-hidden="true">
      <i class="fa" [ngClass]="isMaintenanceActive() ? 'fa-clock-o' : 'fa-exclamation-triangle'"></i>
    </div>
    <div class="smb-content">
      <p class="smb-title">
        <ng-container *ngIf="!isMaintenanceActive()">Scheduled Maintenance</ng-container>
        <ng-container *ngIf="isMaintenanceActive()">Transactions Temporarily Unavailable</ng-container>
      </p>
      <p class="smb-text">
        <ng-container *ngIf="!isMaintenanceActive()">
          On <strong>{{ serverMaintenance.windowLabel }}</strong> our servers will be undergoing maintenance and
          <strong>won&rsquo;t be able to process transactions</strong>. Please complete your payment after this window.
        </ng-container>
        <ng-container *ngIf="isMaintenanceActive()">
          We&rsquo;re performing scheduled maintenance until <strong>{{ serverMaintenance.endLabel }} {{ serverMaintenance.tzLabel }}</strong> and
          <strong>can&rsquo;t process transactions</strong> right now. Please try again after this window ends.
        </ng-container>
      </p>
    </div>
    <button type="button" class="smb-close" *ngIf="!isMaintenanceActive()"
      (click)="dismissMaintenance()" aria-label="Dismiss notice">
      <i class="fa fa-times"></i>
    </button>
  </div>
</div>
<div
  [ngClass]="hide_header_footer == 1 ? 'financing-iframe' : checkLocation('/plans/') || checkLocation('/pay-now/') || checkLocation('/pay-recurring/') ? '' : checkLocation('/personal-details/') ? 'bg_gray' : ''">
  <!-- <app-header *ngIf="hide_header_footer != 1" [ngClass]="{'responsive-designs': mobile_designs == 1}"></app-header> -->
  <section [ngClass]="{'p-0': !is_iframe, 'd-flex align-items-center': checkLocation('/invalid'), 'position-relative': routeAddBank}">
    <div class="content-wrapper"
      [ngClass]="!checkLocation('/plans/') && !checkLocation('/pay-now/') && !checkLocation('/pay-recurring/') && !checkLocation('/personal-details/') && 
      !checkLocation('/payment-details/') &&  !checkLocation('/payment-success/') && !checkLocation('/payment-decline/') && 
      !checkLocation('/payment-process/') && !checkLocation('/credee-bill/')  && !checkLocation('/pre-approval-application/') && !checkLocation('/subscription/proposal/') && 
      !checkLocation('add-subscription-card') && !checkLocation('add-card') && !checkLocation('plans-v2/') && !checkLocation('customer-detail/') && !checkLocation('payment-flow/') &&
       !checkLocation('bank') && !checkLocation('payment-options') ? 'container-lg' : ''">
      <!-- <toaster-container [toasterconfig]="mainService.config"></toaster-container> -->
      <router-outlet *ngIf="!errorMessage" (activate)="onActivate($event)"></router-outlet>
      <p *ngIf="errorMessage"> {{errorMessage}} </p>
    </div>
  </section>
  <!-- <section *ngIf="contribute_card_panel" [ngClass]="card_panel ? 'card-panel' : 'contribute-panel'">
    <toaster-container [toasterconfig]="mainService.config"></toaster-container>
    <router-outlet *ngIf="!errorMessage" (activate)="onActivate($event)"></router-outlet>
    <p *ngIf="errorMessage"> {{errorMessage}} </p>
  </section> -->
  <div *ngIf="mobile_designs == 1 && !checkLocation('/plans/') && !checkLocation('/pay-now/') && !checkLocation('/pay-recurring/')  && !checkLocation('/personal-details/') && !checkLocation('/payment-details/') &&  !checkLocation('/credee-bill/') && !checkLocation('plans-v2/') && !checkLocation('customer-detail/') && !checkLocation('payment-flow/')" class="mobile-contact-support">
    <p class="text-center m-0">
      For technical support contact <a href="https://www.Credee.com/support" target="_blank">Credee</a>
    </p>
    <p class="text-center">
      For plans related support contact <a
        href="tel:{{planInfo && planInfo.practice_mobile ?planInfo.practice_mobile:planInfo.doctor_phone}}">Business</a>
    </p>
  </div>
  <!-- <footer *ngIf="checkLocation('/thanks/')" class="footer text-center footer_plans w-100 mt-4 me-5">
    <div class="text-big" style="margin-right: 2px;">
      <span *ngIf="planInfo && (planInfo.practice_name || planInfo.doctor_first_name) && mainService.contractSupport">
        <span class="m-0 f-s-16 small-mob color-gray">
          In case of any additional queries, please contact your service provider
          <b>{{planInfo && planInfo.practice_name ? planInfo.practice_name : planInfo.doctor_first_name+'
            '+planInfo.doctor_last_name}}</b>
          <span *ngIf="(planInfo.practice_mobile || planInfo.doctor_phone || planInfo.doctor_mobile)"> at </span>
          <a class="text-bold"
            *ngIf="planInfo && (planInfo.practice_mobile || planInfo.doctor_phone || planInfo.doctor_mobile)"
            href="tel:{{planInfo && planInfo.practice_mobile ?planInfo.practice_mobile:planInfo.doctor_phone}}">
            {{(planInfo && planInfo.practice_mobile ? (planInfo.practice_mobile) :
            (planInfo.doctor_phone) ? (planInfo.doctor_phone) :
            (planInfo.doctor_mobile)) | phoneNumber : "N.A"}}
          </a>
        </span>
  
      </span>
      <span *ngIf="planInfo && (planInfo.practice_name || planInfo.doctor_first_name) && !mainService.contractSupport">
        <span class="m-0 f-s-16 small-mob color-gray fw-700">
          Need Help? <a class="text-bold" style="color: #1581E5" href="https://www.denefits.com/request-a-callback/"
            target="_blank">Click Here</a> to contact Denefits
          Support
        </span>
      </span>
      <span class="color-gray fw-700">
        &copy; {{date | date:'yyyy'}} - {{settingsData &&
        settingsData.brand?settingsData.brand.name:'Denefits'}}
      </span>
    </div>
  </footer> -->

  <!-- <app-footer *ngIf="hide_header_footer != 1" class="footer-container ms-0" [ngClass]="{'responsive-designs': mobile_designs == 1}"></app-footer> -->
</div>
<app-captcha></app-captcha>
<div class="gtranslate_wrapper" (click)="startLanguagePolling(1)" *ngIf="this.mainService.showLanguage"></div>
<div id="loading-overlay" *ngIf="loader">
  <div class="sk-wave">
    <div class="sk-rect sk-rect1"></div>
    <div class="sk-rect sk-rect2"></div>
    <div class="sk-rect sk-rect3"></div>
    <div class="sk-rect sk-rect4"></div>
    <div class="sk-rect sk-rect5"></div>
  </div>
</div>